import * as React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Slide,
  Card,
  CardActionArea,
  Stack,
  Typography,
  Grid,
} from "@mui/material";
import { Formik, Form } from "formik";
import TextfieldWrapper from "../../../../../../../Components/FormComponents/TextfieldWrapper";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function MonthlyConstants({
  createMonthlyConstants,
  monthDefaults,
  month,
  updateMonthlyConstants,
  monthDefaultsCheck,
  selectedCard, // Added selectedCard prop
}) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <CardActionArea
        onClick={handleClickOpen}
        sx={{
          width: "200px",
          height: "100%",
          borderRadius: 2,
          overflow: "hidden",
          transition: "transform 0.2s ease-in-out",
          backgroundColor: monthDefaultsCheck?.id ? "#e0f7fa" : "#fff3e0",
          "&:hover": {
            transform: "scale(1.02)",
            boxShadow: 4,
          },
        }}
      >
        <Card
          elevation={0}
          sx={{
            width: "100%",
            height: "100%",
            p: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
          }}
        >
          <Typography variant="caption" fontWeight={600} gutterBottom>
            {selectedCard?.title || ""}
          </Typography>

          <Stack>
            <Typography variant="caption">
              Working Days: {monthDefaults?.workingDays ?? 0}
            </Typography>
            <Typography variant="caption">
              Hours/Day: {monthDefaults?.workingHoursPerDay ?? 0}
            </Typography>
          </Stack>
        </Card>
      </CardActionArea>

      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        maxWidth="sm"
        fullWidth
        onClose={handleClose}
        aria-describedby="monthly-constants-dialog"
      >
        <DialogTitle>Set Monthly Constants</DialogTitle>
        <DialogContent>
          <Formik
            enableReinitialize
            initialValues={{
              workingDays: monthDefaults?.workingDays ?? 0,
              workingHoursPerDay: monthDefaults?.workingHoursPerDay ?? 0,
              month: month ?? "",
              type: selectedCard?.type ?? "", // Use selectedCard prop
            }}
            onSubmit={async (values, { resetForm }) => {
              try {
                if (monthDefaultsCheck?.id) {
                  await updateMonthlyConstants({
                    ...values,
                    id: monthDefaultsCheck.id, // ✅ Ensure this is UUID
                  });
                } else {
                  await createMonthlyConstants(values);
                }
                handleClose();
                resetForm();
              } catch (err) {
                console.error("Error submitting form:", err);
              }
            }}
          >
            {() => (
              <Form>
                <Grid container spacing={2} sx={{ mt: 2 }}>
                  <Grid item xs={6}>
                    <TextfieldWrapper
                      name="workingDays"
                      label="Working Days"
                      type="float"
                      inputProps={{ min: 0, step: 1 }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextfieldWrapper
                      name="workingHoursPerDay"
                      label="Working Hours Per Day"
                      type="float"
                      inputProps={{ min: 0, step: 0.5 }}
                    />
                  </Grid>
                </Grid>

                <DialogActions sx={{ mt: 2 }}>
                  <Button onClick={handleClose} variant="outlined">
                    Cancel
                  </Button>
                  <Button type="submit" variant="contained" color="primary">
                    Save
                  </Button>
                </DialogActions>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
    </>
  );
}
